import store from "@/store/index";
import {Message, Loading} from "element-ui";
import {CtiCloudHelper} from "@/utils/helper/ctiCloud.helper";
import {rgybHelper} from "@/utils/helper/rgyb.helper";
import {callerWindowState} from "@/utils/helper/caller.window.state";

// 不同话务的统一入口
class CallerHelper {
  callId = null;
  setupMsgIns = null;
  setupMsgInsTimeout = null
  // callCheckTimer = null;  //是否允许外呼 查询计时器
  helper = new CtiCloudHelper();
  constructor() {}

  isTianRun() {
    return store.state.global.lusUserCti.type === "TR";
  }
  isRgyb() {
    return store.state.global.lusUserCti.type === "RGYB";
  }
  setCallId(cId) {
    this.callId = cId
  }
  // 注册
  register(registerOption) {
    // console.log('fs-register-lusUserCti =>', {...store.state.global.lusUserCti});

    // 监听页面卸载事件
    window.addEventListener('beforeunload', (event) => {
      // 取消事件
      event.preventDefault();
      // Chrome 需要设置 returnValue
      event.returnValue = '您确定要离开此页面吗？您的更改可能不会保存';
      callHelper && callHelper.logOut && callHelper.logOut();
      // 返回提示消息（部分浏览器可能忽略）
      return '您确定要离开此页面吗？您的更改可能不会保存。';
    });

    if (this.isTianRun()) {
      this.helper = new CtiCloudHelper()
    } else if (this.isRgyb()){
      this.helper = new rgybHelper();
    } else {
      console.log("系统消息", "未配置cti账号");
    }
    if (this.helper) this.helper.register(registerOption);
  }
  // 外呼前置校验
  makeCallBefore(params={}){
    // if (this.callCheckTimer) clearInterval(this.callCheckTimer);
    Message.closeAll();

    const {callWindowStatus} = callerWindowState;
    if (['ON_RING', 'ON_CALLING'].includes(callWindowStatus)) {
      Message.error("请先完成当前通话！");
      return
    }
    const payload = {
      phone: params.phone,
      jobOrderId: params.id,
    }
    store.dispatch('customer/canCallCheck', payload).then(res => {
      const {code, data} = res;
      if (!(code === '000000' && data)){
        Message.warning('暂时不可拨打该用户！');
        return;
      }
      const {time=0} = data;

      // 如果可以拨打
      if (data.isCall === 1){
        this.makeCall(params);
        return;
      }
      Message.warning(data.msg || `已有客服联系过该客户，（${time}）后可再次进行拨打，先联系其他客户吧~`);
    })
  }
  // 建立外呼
  makeCall(params={}) {
    console.log('makeCall-row-detail =>', {...params});
    const {lusUserCti} = store.state.global;

    if (callerWindowState.isCalling) {
      Message.error("呼叫正在建立中");
      return
    }

    // 打开 loading
    callerWindowState.isCalling = true;
    this.setupMsgIns = Loading.service({
      lock: true,
      text: '呼叫正在建立中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    // 超时关闭 loading
    setTimeout(() => {
      // if (callerWindowState.callWindowStatus === "ON_WAITING") {
        callerWindowState.isCalling = false;
        this.setupMsgIns.close();
      // }
    }, 8000);

    callerWindowState.currentCallCusId = params.id;

    this.helper.makeCall(params.phone.toString(), {
      name: params.name,
      agentId: lusUserCti.id,
      // customerId: params.id,
      jobOrderId: params.id,
      callId: "",
      realPhone: params.phone,
    })
  }
  // 挂断
  hangup() {
    const { callWindowStatus, currentTime } = callerWindowState
    if (callWindowStatus === 'ON_RING' && Number(currentTime) < 20) {
      Message.error("呼叫时间目前未超过20秒，不能挂断~")
      return
    }
    this.helper.hangup();
  }
  // 来电
  sipLink() {
    this.setupMsgIns = Loading.service({
      lock: true,
      text: '通话正在接听，请稍等~',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    callerWindowState.showInComingDrawer = false
    setTimeout(() => {
      this.setupMsgIns.close();
    }, 8000);
    this.setupMsgInsTimeout = setTimeout(() => {
      Message.error("本次通话接听失败~");
      this.hangup();
    }, 60000)

    this.helper.sipLink();
  }
  // 拒接
  refuse() {
    callerWindowState.showInComingDrawer = false
    this.helper.refuse();
  }
  // 设置忙碌
  pause() {this.helper.pause();}
  // 设置在线
  unpause() {this.helper.unpause();}
  // 呼叫保持，通话时坐席操作呼叫保持后，用户端收听背景音，坐席可以与其他人讲话（用户听不到坐席侧的声音）
  holdCall() {this.helper.holdCall();}
  // 取消呼叫保持，保持中的通话，坐席可以取消呼叫保持，取消后，用户端恢复与坐席正常的双向通话（彼此听到对方声音）
  unHold() {this.helper.unHold();}
  // 关闭自动外呼
  closeAutoDial() {this.helper.closeAutoDial();}
  // 打开自动外呼
  startAutoDial() {this.helper.startAutoDial();}
  // 退出登录
  logOut(callback){this.helper.logOut(callback);}
}

export const callHelper = new CallerHelper;
